(function () {
  var INTERVAL_MS = 2800;
  var galleryAttr = 'data-effilo-hover-gallery';
  var activeClass = 'is-active';
  var timerKey = '_effiloHoverTimer';
  var indexKey = '_effiloHoverIndex';
  var activeMobileTile = null;

  // Theme mobile breakpoint — not hover media (DevTools / some devices still report hover).
  var mobileQuery = window.matchMedia('(max-width: 989px)');
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  /**
   * Returns true when the viewport is at the theme mobile breakpoint.
   * @returns {boolean}
   */
  function isMobileView() {
    return mobileQuery.matches;
  }

  /**
   * Desktop hover gallery is allowed only off mobile and when motion is OK.
   * @returns {boolean}
   */
  function canHoverCycle() {
    return !isMobileView() && !reduceMotionQuery.matches;
  }

  /**
   * Mobile touch gallery is allowed only on mobile and when motion is OK.
   * @returns {boolean}
   */
  function canTouchCycle() {
    return isMobileView() && !reduceMotionQuery.matches;
  }

  /**
   * Collects stacked gallery images inside a product tile.
   * @param {Element} tile
   * @returns {NodeListOf<Element>}
   */
  function getImages(tile) {
    return tile.querySelectorAll('.effilo-product-tile__image');
  }

  /**
   * Shows one gallery image and hides the rest.
   * @param {NodeListOf<Element>|Element[]} images
   * @param {number} index
   */
  function setActive(images, index) {
    Array.prototype.forEach.call(images, function (img, i) {
      img.classList.toggle(activeClass, i === index);
    });
  }

  /**
   * Clears the per-tile interval if one is running.
   * @param {Element} tile
   */
  function clearHoverTimer(tile) {
    if (tile[timerKey]) {
      clearInterval(tile[timerKey]);
      tile[timerKey] = null;
    }
  }

  /**
   * Stops cycling and resets a tile to the first image.
   * @param {Element} tile
   */
  function stopCycle(tile) {
    clearHoverTimer(tile);
    var images = getImages(tile);
    if (!images.length) return;
    tile[indexKey] = 0;
    setActive(images, 0);
  }

  /**
   * Starts cycling gallery images on a tile from an optional index.
   * @param {Element} tile
   * @param {number} [startIndex]
   */
  function startCycle(tile, startIndex) {
    var images = getImages(tile);
    if (images.length < 2) return;

    clearHoverTimer(tile);

    if (reduceMotionQuery.matches) {
      setActive(images, 0);
      return;
    }

    var initial = typeof startIndex === 'number' ? startIndex : 1;
    tile[indexKey] = initial % images.length;
    setActive(images, tile[indexKey]);

    tile[timerKey] = setInterval(function () {
      var next = ((tile[indexKey] || 0) + 1) % images.length;
      tile[indexKey] = next;
      setActive(images, next);
    }, INTERVAL_MS);
  }

  /**
   * Finds the nearest hover-gallery tile from an event target.
   * @param {EventTarget|null} target
   * @returns {Element|null}
   */
  function findGallery(target) {
    if (!(target instanceof Element)) return null;
    return target.closest('[' + galleryAttr + ']');
  }

  /**
   * Stops any mobile tile that is currently cycling.
   */
  function stopActiveMobileTile() {
    if (!activeMobileTile) return;
    stopCycle(activeMobileTile);
    activeMobileTile = null;
  }

  /**
   * Starts mobile gallery cycling for one touched tile (stops any previous).
   * @param {Element} tile
   */
  function activateMobileTile(tile) {
    if (activeMobileTile === tile) return;
    stopActiveMobileTile();
    activeMobileTile = tile;
    startCycle(tile, 1);
  }

  /**
   * Resets all gallery tiles and clears mobile active state (e.g. breakpoint change).
   */
  function teardownAll() {
    stopActiveMobileTile();
    document.querySelectorAll('[' + galleryAttr + ']').forEach(function (tile) {
      stopCycle(tile);
    });
  }

  document.addEventListener(
    'mouseenter',
    function (event) {
      if (!canHoverCycle()) return;
      var tile = findGallery(event.target);
      if (!tile || tile[timerKey]) return;
      startCycle(tile, 1);
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    function (event) {
      if (!canHoverCycle()) return;
      var tile = findGallery(event.target);
      if (!tile) return;
      var related = event.relatedTarget;
      if (related instanceof Node && tile.contains(related)) return;
      stopCycle(tile);
    },
    true
  );

  // Mobile: only cycle the product the shopper touches (not every visible card).
  document.addEventListener(
    'touchstart',
    function (event) {
      if (!canTouchCycle()) return;
      var tile = findGallery(event.target);
      if (tile) {
        activateMobileTile(tile);
        return;
      }
      stopActiveMobileTile();
    },
    { capture: true, passive: true }
  );

  /**
   * Syncs desktop vs mobile mode when breakpoint or motion preference changes.
   */
  function syncMode() {
    teardownAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMode);
  } else {
    syncMode();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncMode);
    reduceMotionQuery.addEventListener('change', syncMode);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(syncMode);
    reduceMotionQuery.addListener(syncMode);
  }
})();
